var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.119 6.77793C24.809 6.36793 24.339 6.12793 23.819 6.12793H21.399L21.099 7.12793H23.819C24.019 7.12793 24.199 7.21793 24.319 7.37793C24.439 7.53793 24.469 7.73793 24.419 7.92793L21.119 18.9979C21.039 19.2579 20.799 19.4379 20.529 19.4379H7.09896C6.89896 19.4379 6.71896 19.3479 6.59896 19.1879C6.47896 19.0279 6.44896 18.8279 6.49896 18.6379L6.98896 16.9979H5.94896L5.54896 18.3579C5.39896 18.8579 5.48896 19.3779 5.79896 19.7879C6.10896 20.1979 6.57896 20.4379 7.09896 20.4379H20.509C21.219 20.4379 21.859 19.9579 22.059 19.2779L25.359 8.20793C25.509 7.70793 25.419 7.18793 25.109 6.77793H25.119Z",
    fill: "#B1B1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.219 14.6379H1.80903C1.05903 14.6379 0.519031 13.9179 0.739031 13.1979L4.03903 2.12788C4.17903 1.65788 4.61903 1.32788 5.10903 1.32788H18.519C19.269 1.32788 19.809 2.04788 19.589 2.76788L16.289 13.8379C16.149 14.3079 15.709 14.6379 15.219 14.6379Z",
    stroke: "#B1B1B1",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayerIcon);
export default __webpack_public_path__ + "static/media/layerIcon.92af0f2d3c1565c89ed3d9e2e0dd6074.svg";
export { ForwardRef as ReactComponent };